import { BaseViewStore } from 'core/stores';
import { action } from 'mobx';
import { UpdateBuyShippingForm } from 'modules/order/forms';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { onUpdateBuyShippingStatuses, sourceOfChange } from 'common/constants';
import { formInvalidate, translate } from 'core/utils';
import { channelType } from 'common/constants';
import _ from 'lodash';

class UpdateBuyShippingViewStore extends BaseViewStore {
	form = new UpdateBuyShippingForm({
		onSuccess: async () => {
			await this.updateBuyShippingBulk();
		},
	});

	constructor(rootStore, { parentViewStore, selectedItems }) {
		super(rootStore);
		this.parentView = parentViewStore;
		this.selectedItems = selectedItems;
		this.fulfillmentOrderStore = new FulfillmentOrderStore(rootStore);
		this.form.$('useBuyShipping').set(true);
	}

	@action.bound async updateBuyShippingBulk() {
		this.suspend();
		try {
			const selectedItems = [];
			this.selectedItems.map(async selectedItem => {
				let index = _.findIndex(onUpdateBuyShippingStatuses, item => item == selectedItem.fulfillmentOrderStatusAbrv);
				if (index != -1 && selectedItem.orderChannelType == channelType.amazon) {
					selectedItems.push(selectedItem);
				}
			});
			const useBuyShipping = this.form.$('useBuyShipping').value;
			const fulfillmentOrderIds = _.map(selectedItems, item => {
				return item.id;
			});
			this.parentView.selectedItems.forEach(o => delete o.isChecked);
			this.parentView.isSelectAllCheckboxSelected = false;
			if (this.parentView.selectedGroupByOption) {
				this.parentView.selectedGroups.forEach(g => delete g.isChecked);
				this.parentView.selectedGroups = [];
			}
			this.parentView.selectedItems = [];
			if (selectedItems.length > 0) {
				const count = await this.fulfillmentOrderStore.updateBuyShippingBulk(
					{ fulfillmentOrderIds: fulfillmentOrderIds, useBuyShipping: useBuyShipping },
					sourceOfChange.updateBuyShippingBulk
				);
				if (count > 0) {
					this.rootStore.notificationStore.success(['UPDATEBUYSHIPPINGVIEW.SUCCESSBULK', { count: count }]);
				} else {
					this.rootStore.notificationStore.error('UPDATEBUYSHIPPINGVIEW.NOVALIDORDERSELECTED');
				}
			} else {
				this.rootStore.notificationStore.error('UPDATEBUYSHIPPINGVIEW.NOVALIDORDERSELECTED');
			}
			this.parentView.reload = true;
			this.parentView.updateBuyShippingModalBulk.close();
		} catch (err) {
			formInvalidate({ form: this.form, err });
		}
		this.resume();
	}
}

export default UpdateBuyShippingViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/UpdateBuyShippingViewStore.js